import { useState } from 'react'

type Tab = 'club' | 'photo' | 'mgmt' | 'combined'

const TABS: { id: Tab; label: string }[] = [
  { id: 'club',     label: 'I work for a venue'      },
  { id: 'photo',    label: "I'm a photographer"       },
  { id: 'mgmt',     label: "I'm in artist management" },
  { id: 'combined', label: 'A bit of everything'      },
]

const inp: React.CSSProperties = {
  width: '100%', fontFamily: 'inherit', fontSize: 14,
  background: '#fff', color: '#1a1a18',
  border: '0.5px solid #ccc9c0', borderRadius: 6,
  padding: '10px 13px', lineHeight: 1.5, boxSizing: 'border-box',
}
const ta: React.CSSProperties = { ...inp, minHeight: 88, resize: 'vertical' }

function SL({ children }: { children: React.ReactNode }) {
  return <div style={{ fontSize: 11, fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#a09d94', margin: '2rem 0 1rem', paddingBottom: 8, borderBottom: '0.5px solid #e4e2db' }}>{children}</div>
}

function F({ label, sub, children }: { label: string; sub?: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: '1.4rem' }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 500, color: '#1a1a18', marginBottom: 6, lineHeight: 1.4 }}>
        {label}{sub && <span style={{ fontWeight: 400, color: '#6b6960', marginLeft: 4 }}>{sub}</span>}
      </label>
      {children}
    </div>
  )
}

function R({ name, value, label }: { name: string; value: string; label: string }) {
  return (
    <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 14, color: '#1a1a18', cursor: 'pointer', lineHeight: 1.5 }}>
      <input type="radio" name={name} value={value} style={{ marginTop: 3, flexShrink: 0 }} />{label}
    </label>
  )
}

function Two({ children }: { children: React.ReactNode }) {
  return <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>{children}</div>
}

function Sub({ onClick }: { onClick: () => void }) {
  return (
    <div style={{ marginTop: '1.8rem', paddingTop: '1.4rem', borderTop: '0.5px solid #e4e2db', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' as const }}>
      <span style={{ fontSize: 12, color: '#a09d94' }}>Answers go to Lance Adams at The Room</span>
      <button onClick={onClick} style={{ fontFamily: 'inherit', fontSize: 13, fontWeight: 500, color: '#1a1a18', background: '#fff', border: '0.5px solid #ccc9c0', borderRadius: 6, padding: '10px 22px', cursor: 'pointer' }}>
        Send answers →
      </button>
    </div>
  )
}

function g(id: string) { const el = document.getElementById(id) as HTMLInputElement | null; return el?.value.trim() ?? '' }
function rv(name: string) { const el = document.querySelector(`input[name="${name}"]:checked`) as HTMLInputElement | null; return el?.value ?? '—' }

function doSubmit(type: string, onDone: () => void) {
  let respondent = '', data: Record<string, string> = {}
  if (type === 'club') {
    respondent = 'Club / venue'
    data = { name: g('c-name'), role: g('c-role'), email: g('c-email'), photographers_per_night: g('c-q1'), what_you_need_and_when: g('c-q2'), what_actually_happens: g('c-q3'), where_it_breaks_down: g('c-q4'), worst_example: g('c-q5'), tried_to_fix: g('c-q6'), what_good_looks_like: g('c-q7'), anything_else: g('c-q8') }
  } else if (type === 'photo') {
    respondent = 'Photographer'
    data = { name: g('p-name'), shooting_setup: g('p-q1'), email: g('p-email'), frames_per_night: g('p-q2'), post_shoot_process: g('p-q3'), edit_process: g('p-q4'), when_venue_wants_faster: g('p-q5'), most_frustrating: g('p-q6'), sent_unedited_before: g('p-q7'), preview_before_edit: rv('p-preview'), what_good_looks_like: g('p-q8'), anything_else: g('p-q9') }
  } else if (type === 'mgmt') {
    respondent = 'Artist management'
    data = { name: g('m-name'), role: g('m-role'), email: g('m-email'), artists_managed: g('m-q1'), how_find_out_images_exist: g('m-q2'), how_commercial_requests_arrive: g('m-q3'), standard_terms: g('m-q4'), unauthorised_use: rv('m-unauth'), bad_outcome_example: g('m-q5'), biggest_headache: g('m-q6'), single_inbox_wants: g('m-q7'), commercial_vs_risk: rv('m-commercial'), anything_else: g('m-q8') }
  } else {
    respondent = 'Combined'
    data = { name: g('x-name'), role: g('x-role'), email: g('x-email'), respondent_type: rv('x-who'), how_it_works_now: g('x-q1'), when_it_works: g('x-q2'), when_it_goes_wrong: g('x-q3'), turnaround_reality: g('x-q4'), permissions_and_commercial_use: g('x-q5'), problem_example: g('x-q6'), what_good_looks_like: g('x-q7'), anything_else: g('x-q8') }
  }
  const name = data.name || 'no name'
  const emailLine = data.email ? `Reply-to: ${data.email}\n\n` : ''
  const subject = `Discovery — ${respondent} — ${name}`
  const skip = new Set(['name', 'email'])
  const body = emailLine + Object.entries(data).filter(([k]) => !skip.has(k)).map(([k, v]) => `${k.replace(/_/g, ' ')}:\n${v || '—'}`).join('\n\n')
  window.location.href = `mailto:lance@ibezamediaroom.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
  setTimeout(onDone, 600)
}

function ClubForm({ onDone }: { onDone: () => void }) {
  return <>
    <SL>Your details</SL>
    <Two><F label="Your name"><input id="c-name" type="text" style={inp} /></F><F label="Your role at the venue"><input id="c-role" type="text" style={inp} placeholder="e.g. Marketing manager" /></F></Two>
    <F label="Your email" sub="— so we can follow up if needed"><input id="c-email" type="email" style={inp} placeholder="you@venue.com" /></F>
    <SL>How photography works now</SL>
    <F label="How many photographers typically shoot at your venue on a busy night?"><input id="c-q1" type="text" style={inp} /></F>
    <F label="When you commission photography, what do you need and by when?"><textarea id="c-q2" style={ta} placeholder="e.g. 20 edited selects by Monday noon for social..." /></F>
    <F label="What typically happens? How long does it actually take?"><textarea id="c-q3" style={ta} /></F>
    <SL>The friction</SL>
    <F label="Where does the process break down most often?"><textarea id="c-q4" style={ta} /></F>
    <F label="What's the worst version of this that's happened?"><textarea id="c-q5" style={ta} /></F>
    <F label="Have you tried anything to fix it? What happened?"><textarea id="c-q6" style={ta} /></F>
    <SL>What good looks like</SL>
    <F label="If this worked perfectly, what would be different?"><textarea id="c-q7" style={ta} /></F>
    <F label="Anything else you'd want us to understand?"><textarea id="c-q8" style={ta} /></F>
    <Sub onClick={() => doSubmit('club', onDone)} />
  </>
}

function PhotoForm({ onDone }: { onDone: () => void }) {
  return <>
    <SL>Your details</SL>
    <Two><F label="Your name"><input id="p-name" type="text" style={inp} /></F><F label="How do you typically shoot?"><input id="p-q1" type="text" style={inp} placeholder="Camera + card, mirrorless to phone..." /></F></Two>
    <F label="Your email" sub="— so we can follow up if needed"><input id="p-email" type="email" style={inp} placeholder="you@email.com" /></F>
    <SL>Your setup</SL>
    <F label="How many frames do you typically shoot on a club night?"><input id="p-q2" type="text" style={inp} /></F>
    <SL>After the shoot</SL>
    <F label="Walk us through what happens after you leave the venue — from end of night to delivering to the client"><textarea id="p-q3" style={{ ...ta, minHeight: 100 }} placeholder="Where are the files, when do you start editing, how long does it take..." /></F>
    <F label="What does your edit process actually look like?" sub="Software, how you cull, how long"><textarea id="p-q4" style={ta} /></F>
    <F label="When a venue wants content faster than your normal timeline, what happens?"><textarea id="p-q5" style={ta} /></F>
    <SL>The friction</SL>
    <F label="What's the most frustrating part of working with venues on content delivery?"><textarea id="p-q6" style={ta} /></F>
    <F label="Have you ever sent unedited or lightly processed work to a client before your full edit was done? How did that go?"><textarea id="p-q7" style={ta} /></F>
    <F label="How would you feel about venues or management seeing low-resolution watermarked previews of unedited frames before your edit is complete?" sub="Gut reaction.">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
        <R name="p-preview" value="fine" label="Fine — it's practical and I understand why they'd want that" />
        <R name="p-preview" value="conditional" label="Depends on the terms and who exactly is seeing them" />
        <R name="p-preview" value="uncomfortable" label="Uncomfortable — my edit is part of the work, not just the shot" />
        <R name="p-preview" value="no" label="No — I don't send unfinished work under any circumstances" />
      </div>
    </F>
    <SL>What good looks like</SL>
    <F label="If the relationship with venues around content delivery worked perfectly for you, what would be different?"><textarea id="p-q8" style={ta} /></F>
    <F label="Anything else?"><textarea id="p-q9" style={ta} /></F>
    <Sub onClick={() => doSubmit('photo', onDone)} />
  </>
}

function MgmtForm({ onDone }: { onDone: () => void }) {
  return <>
    <SL>Your details</SL>
    <Two><F label="Your name"><input id="m-name" type="text" style={inp} /></F><F label="Your role"><input id="m-role" type="text" style={inp} placeholder="e.g. Manager, PA" /></F></Two>
    <F label="Your email" sub="— so we can follow up if needed"><input id="m-email" type="email" style={inp} placeholder="you@management.com" /></F>
    <F label="Roughly how many artists do you manage or work with?"><input id="m-q1" type="text" style={inp} /></F>
    <SL>How it works now</SL>
    <F label="When a photographer shoots your artist at a venue night, how do you typically find out the images exist?"><textarea id="m-q2" style={ta} /></F>
    <F label="How do requests to use images commercially reach you?"><textarea id="m-q3" style={ta} placeholder="Email, WhatsApp, through the venue, other..." /></F>
    <F label="Do you have standard terms for photography of your artists? If so, how are they communicated to photographers?"><textarea id="m-q4" style={ta} /></F>
    <SL>The friction</SL>
    <F label="Has content of your artists been used commercially without your knowledge or approval?">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
        <R name="m-unauth" value="regularly" label="Yes, regularly" />
        <R name="m-unauth" value="occasionally" label="Yes, occasionally" />
        <R name="m-unauth" value="rarely" label="Rarely, but it has happened" />
        <R name="m-unauth" value="no" label="Not that I know of" />
      </div>
    </F>
    <F label="What does a bad outcome look like — a specific example if you can share one?"><textarea id="m-q5" style={ta} /></F>
    <F label="What takes the most time or causes the most headaches in managing this area?"><textarea id="m-q6" style={ta} /></F>
    <SL>What good looks like</SL>
    <F label="If you had a single place where all photography of your artists from venue nights came in — what would you want to be able to do with it?"><textarea id="m-q7" style={ta} /></F>
    <F label="Is commercial clearance of venue photography a revenue opportunity or mainly risk management?">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
        <R name="m-commercial" value="revenue" label="Revenue opportunity — yes, there's money we're not capturing" />
        <R name="m-commercial" value="both" label="Both — it's a revenue opportunity and a risk" />
        <R name="m-commercial" value="risk" label="Mainly risk management — just want to stop unauthorised use" />
        <R name="m-commercial" value="neither" label="Neither is a significant priority right now" />
      </div>
    </F>
    <F label="Anything else you'd want us to understand?"><textarea id="m-q8" style={ta} /></F>
    <Sub onClick={() => doSubmit('mgmt', onDone)} />
  </>
}

function CombinedForm({ onDone }: { onDone: () => void }) {
  return <>
    <SL>Your details</SL>
    <Two><F label="Your name"><input id="x-name" type="text" style={inp} /></F><F label="Your role"><input id="x-role" type="text" style={inp} placeholder="e.g. Club promoter, Photographer" /></F></Two>
    <F label="Your email" sub="— so we can follow up if needed"><input id="x-email" type="email" style={inp} placeholder="you@email.com" /></F>
    <F label="Which of these best describes you?">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 8 }}>
        <R name="x-who" value="venue" label="I work for a venue or promoter" />
        <R name="x-who" value="photographer" label="I'm a photographer" />
        <R name="x-who" value="management" label="I work in artist management" />
        <R name="x-who" value="multiple" label="I wear more than one of these hats" />
      </div>
    </F>
    <SL>How photography works now</SL>
    <F label="Describe how photography at events currently works from your side — what happens, who does what, what the timelines look like"><textarea id="x-q1" style={{ ...ta, minHeight: 100 }} /></F>
    <F label="When it works well, what makes it work?"><textarea id="x-q2" style={ta} /></F>
    <F label="When it goes wrong, what goes wrong?"><textarea id="x-q3" style={ta} /></F>
    <SL>Specific friction points</SL>
    <F label="How quickly do images typically need to be available after an event, and does that actually happen?"><textarea id="x-q4" style={ta} /></F>
    <F label="How are permissions and commercial use of images handled in your experience?"><textarea id="x-q5" style={ta} placeholder="Formal, informal, ad hoc — who's involved, how decisions get made..." /></F>
    <F label="Has content been used in a way that caused a problem — for you or someone you work with?"><textarea id="x-q6" style={ta} /></F>
    <SL>What good looks like</SL>
    <F label="If the whole photography-to-delivery process worked better, what would be different from where you sit?"><textarea id="x-q7" style={{ ...ta, minHeight: 100 }} /></F>
    <F label="Anything else you'd want us to know?"><textarea id="x-q8" style={ta} /></F>
    <Sub onClick={() => doSubmit('combined', onDone)} />
  </>
}

export default function DiscoveryPage() {
  const [tab, setTab] = useState<Tab>('club')
  const [done, setDone] = useState<Tab | null>(null)

  const intros: Record<Tab, { h: string; p: string }> = {
    club:     { h: 'A few questions about photography at your venue',               p: "We're trying to understand how photography works in practice — what's going well, where the friction is. Five minutes, no right answers." },
    photo:    { h: 'A few questions about how you work',                             p: "We're trying to understand the reality of a photographer's post-shoot process — not what it should be, what it actually is. Five minutes." },
    mgmt:     { h: 'A few questions about how content of your artists reaches you',  p: "We're trying to understand how artist management currently deals with photography from venue nights — what works, what doesn't. Five minutes." },
    combined: { h: 'A few questions about photography at events',                    p: "We're building tools to make the photography process work better for everyone involved. Five to ten minutes." },
  }

  return (
    <div style={{ fontFamily: 'system-ui, sans-serif', background: '#fafaf8', minHeight: '100vh', paddingBottom: '4rem' }}>
      <div style={{ padding: '2.5rem 0 2rem', textAlign: 'center', borderBottom: '0.5px solid #e4e2db', marginBottom: '2.5rem' }}>
        <p style={{ fontSize: 11, fontWeight: 500, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#a09d94', marginBottom: 10 }}>The Room — Discovery</p>
        <h1 style={{ fontSize: 26, fontWeight: 400, color: '#1a1a18', lineHeight: 1.2, fontFamily: 'Georgia, serif' }}>How does photography at events actually work?</h1>
      </div>

      <div style={{ maxWidth: 640, margin: '0 auto', padding: '0 24px' }}>
        <div style={{ display: 'flex', borderBottom: '0.5px solid #e4e2db', marginBottom: '2.5rem', overflowX: 'auto' as const }}>
          {TABS.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{ fontFamily: 'inherit', fontSize: 13, fontWeight: tab === t.id ? 500 : 400, color: tab === t.id ? '#1a1a18' : '#6b6960', background: 'none', border: 'none', borderBottom: tab === t.id ? '2px solid #1a1a18' : '2px solid transparent', padding: '10px 14px 13px', cursor: 'pointer', whiteSpace: 'nowrap' as const, marginBottom: -1 }}>
              {t.label}
            </button>
          ))}
        </div>

        <div style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: 21, fontWeight: 400, color: '#1a1a18', marginBottom: 8, lineHeight: 1.3, fontFamily: 'Georgia, serif' }}>{intros[tab].h}</h2>
          <p style={{ fontSize: 14, color: '#6b6960', lineHeight: 1.7 }}>{intros[tab].p}</p>
        </div>

        {done === tab
          ? <div style={{ textAlign: 'center', padding: '4rem 2rem' }}><h3 style={{ fontSize: 22, fontWeight: 400, marginBottom: 10, color: '#1a1a18', fontFamily: 'Georgia, serif' }}>Thank you</h3><p style={{ fontSize: 14, color: '#6b6960', lineHeight: 1.7 }}>Your answers have been sent to Lance.<br />We'll be in touch if we have follow-up questions.</p></div>
          : <>
              {tab === 'club'     && <ClubForm     onDone={() => setDone('club')}     />}
              {tab === 'photo'    && <PhotoForm    onDone={() => setDone('photo')}    />}
              {tab === 'mgmt'     && <MgmtForm     onDone={() => setDone('mgmt')}     />}
              {tab === 'combined' && <CombinedForm onDone={() => setDone('combined')} />}
            </>
        }
      </div>

      <div style={{ textAlign: 'center', marginTop: '3rem', paddingTop: '1.5rem', borderTop: '0.5px solid #e4e2db' }}>
        <p style={{ fontSize: 12, color: '#a09d94' }}>The Room — 2026. Your answers are sent directly to Lance and used only for product research.</p>
      </div>
    </div>
  )
}
